import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { getBackendUrl } from "../../config";


import {
  Button,
  CssBaseline,
  TextField,
  Box,
  Typography,
  Container,
  InputAdornment,
  IconButton,
  Link,
  Grid,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  InputLabel,
  Breadcrumbs,
  MenuItem,
  Select
} from '@material-ui/core';

import { Business, SwapHoriz, Visibility, VisibilityOff } from '@material-ui/icons';
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

import { AuthContext } from "../../context/Auth/AuthContext";
import { toast } from "react-toastify";

import packageJson from '../../../package.json';

import logoBlack from '../../assets/logo-send4whats-black.png';
import logoWhite from '../../assets/logo-send4whats-white.png';
import HexToRgb from "../../components/HexToRgb";

const Copyright = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      © {new Date().getFullYear()}
      {" - "}
      <Link color="inherit" href={packageJson.systemVars.support.link} >
        {packageJson.systemVars.appName} - v{packageJson.systemVars.version}
      </Link>
      {"."}
    </Typography>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    paddind: 10,

  },
  gridItem: {
    borderRight: "1px solid silver",
    padding: "20px"
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  tenantList: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },

  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  img: {
    margin: theme.spacing(1),
    marginBottom: "15px",
    paddingBottom: "20px",
    width: "250px",
    borderBottom: "1px solid #cecece",
  },
  link: {
    display: 'flex',
    cursor: 'pointer'
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20,
  },
  tenantListSelect: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.background.paper ,
    border: "grey",
    padding: 25,

  },
}));

const Login = ({ colorTheme }) => {
  const classes = useStyles();

  const [user, setUser] = useState({ email: "", password: "", code: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [tenant, setTenant] = useState();
  const [tenantList, setTenantList] = useState(JSON.parse(window.localStorage.getItem("tenantList")) || []);
  const { handleLogin } = useContext(AuthContext);

  const handleChangeInput = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (window.localStorage.getItem("tenant")) {
      setTenant(window.localStorage.getItem("tenant"));
    }
  }, [tenant]);

  const handlSubmit = (e) => {
    e.preventDefault();
    handleLogin(user);
  };


  async function urlValidate(url) {
    try {
      const response = await axios.get(url);
      if (response.status >= 200 && response.status < 300) {
        console.log(`O URL ${url} existe e está acessível.`);
        return true;
      }
    } catch (error) {
      if (error.response) {

        if (error.response.status === 404) {
          console.log(`O URL ${url} não foi encontrado (404).`);
        } else {
          console.log(`O URL ${url} não está acessível. Código: ${error.response.status}`);
        }
      } else if (error.request) {
        console.log(`Não foi possível obter uma resposta do URL ${url}. Verifique sua conexão ou o URL.`);
      } else {
        console.log('Erro ao configurar a requisição:', error.message);
      }
      return false;
    }
  }

  const handlSubmitTenant = async (e) => {
    e.preventDefault();

    window.localStorage.setItem("tenant", user.tenant);

    const urlvalid = getBackendUrl() + '/settings/publicSettings';
    const resURL = await urlValidate(urlvalid);

    if (!resURL) {
      toast.error("Verifique o nome digitado!");
      return;
    }

    const listKey = 'tenantList';
    let items = JSON.parse(localStorage.getItem(listKey)) || [];
    const newItem = user?.tenant?.toLowerCase();
    items.push(newItem);
    items = [...new Set(items)];
    localStorage.setItem(listKey, JSON.stringify(items));

    setTenantList(items);
    setTenant(user.tenant);
    window.location.reload();

  };

  const handleSetTenant = (e) => {
    if (!e.target.value) return;
    setTenant(e.target.value);
    localStorage.setItem("tenant", e.target.value);
    window.location.reload();
  };

  return (
    <div className={classes.root}>
      <Grid container >
        <Grid item lg={6} xs={6} style={{ borderRight: "1px solid silver" }}
          component={Box}
          className={classes.gridItem}
          display={{ xs: "none", lg: "block" }}
        >

          <Card className={classes.card}>
            <CardActionArea>
              <CardContent>
                <Typography gutterBottom variant="h4" component="h2">
                  API oficial do WhatsApp
                </Typography>
                {/* <p dangerouslySetInnerHTML={{ __html: posts[0].content.rendered }}>teste txexto</p> */}
                <p style={{ fontSize: "16px", lineHeight: "1.5" }}>
                  Já é possível receber e responder mensagens via API oficial do WhatsApp com o Send4Whats.<br />
                  Em breve será possível iniciar uma conversa com seu cliente, usando template WhatsApp.</p>
              </CardContent>
            </CardActionArea>
            <CardActions>
              <Link color="inherit" href="">
                <Button size="small" color="primary">
                  Leia no site...
                </Button>
              </Link>

            </CardActions>
          </Card>


        </Grid>
        <Grid item lg={6} xs={12}>
          <Container component="main" maxWidth="xs" className={classes.paper}>
            <CssBaseline />

            {HexToRgb(colorTheme) === "#000000" ? (
              <img className={classes.img} src={logoWhite} alt="Logo" />
            ) : (
              <img className={classes.img} src={logoBlack} alt="Logo" />
            )}

            {tenant &&
              <form id="login-form" className={classes.form} noValidate onSubmit={handlSubmit}>
                <Breadcrumbs aria-label="breadcrumb">
                  <Typography color="inherit" className={classes.link}>
                    <Business className={classes.icon} /> {`Empresa: ${tenant}`}
                  </Typography>
                </Breadcrumbs>

                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label={i18n.t("login.form.email")}
                  name="email"
                  value={user.email}
                  onChange={handleChangeInput}
                  autoComplete="email"
                  autoFocus
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label={i18n.t("login.form.password")}
                  id="password"
                  value={user.password}
                  onChange={handleChangeInput}
                  autoComplete="current-password"
                  type={showPassword ? 'text' : 'password'}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword((e) => !e)}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  {i18n.t("login.buttons.submit")}
                </Button>

                <Breadcrumbs aria-label="breadcrumb">
                  <Typography
                    color="inherit"
                    href="/"
                    onClick={() => { setTenant(null); localStorage.removeItem("tenant"); }}
                    className={classes.link}
                  >
                    <SwapHoriz className={classes.icon} color="primary" /> Trocar Empresa
                  </Typography>
                </Breadcrumbs>

              </form>
            }
            {!tenant &&

              <form id="login-form-tenant" className={classes.form} noValidate onSubmit={handlSubmitTenant}>

                <div variant="outlined" className={classes.tenantListSelect} >
                  Acesso rápido: Empresas já logadas<br />
                  <span style={{ fontSize: 12, color: "gray" }}>
                    Clique no nome para selecionar.
                  </span>
                  <Select
                    labelId="selectTenantLabel"
                    id="selectTenant"
                    value={tenant}
                    fullWidth
                    onChange={(e) => { handleSetTenant(e) }}
                    label="Selecione uma empresa"
                  >
                    <MenuItem value="">
                      <em>Selecione uma empresa</em>
                    </MenuItem>
                    {tenantList?.map((item, index) => (
                      <MenuItem key={index} value={item}>{`Empresa: ${item}`}</MenuItem>
                    ))}
                  </Select>
                </div>

                <InputLabel style={{ marginTop: 25, marginBottom: 10 }}>
                  Digite o nome da sua empresa (tenant).
                </InputLabel>
                <TextField
                  variant="filled"
                  required
                  fullWidth
                  id="tenant"
                  label={i18n.t("login.form.tenantName")}
                  name="tenant"
                  value={user.tenant}
                  onChange={handleChangeInput}
                  autoComplete="tenant"
                  autoFocus
                />
                <span style={{ fontSize: 12, color: "gray" }}>
                  Caso não saiba o nome, entre em contato com o suporte.
                </span>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  {i18n.t("login.buttons.submit")}
                </Button>

              </form>
            }
            <Box mt={8}><Copyright /></Box>
          </Container>
        </Grid>
      </Grid>
    </div>
  );
};

export default Login;
